<template>
  <div v-html="normalizedDescription" />
</template>

<script setup lang="ts">
const props = defineProps<{ content: string | undefined }>()
const normalizedDescription = computed(() => {
  if (!props.content) return ''
  return props.content
      .replace(/>\s+</g, '><')
      .replace(/\s+/g, ' ')
      .trim()
      .replace(/<([^>]+)\/>/g, '<$1></$1>')
      .replace(/[\n\r]+/g, '')
})
</script>
